// extracted by mini-css-extract-plugin
export default {"validationProcessRunningContainer":"loadingPage_validationProcessRunningContainer__2G4Nt","imageContainer":"loadingPage_imageContainer__HCM3h","header":"loadingPage_header__K6h6B"};